import {StageLayer} from "@nolimitcity/slot-launcher/bin/StageLayer";
import {TheBorder} from "../TheBorder";
import {TheBorderGameAssets} from "../TheBorderGameAssets";
import {TheBorderStatics} from "../TheBorderStatics";
import {TheBorderSound} from "../sound/TheBorderSound";
import {TheBorderScatterSymbol} from "../reels/TheBorderScatterSymbol";

export class TheBorderReelHighlighter extends PIXI.Container implements StageLayer {
    private _animation: PIXI.spine.Spine;
    private _scatterAnticipationSoundPlayed: boolean = false;

    constructor() {
        super();
        this.name = "TheBorderReelHighlighter";
        this.init();
    }

    public highlightReel(reelId: number): void {
        this.resetSpine();
        this._animation.position.x = TheBorderStatics.reelPositions[reelId].x + (TheBorderStatics.symbolWidth * 0.5);
        this._animation.state.setAnimation(0, "highlighter", true);

        if (!this._scatterAnticipationSoundPlayed) {
            TheBorder.backgroundElements.playBackgroundAnim("in", 0);

            TheBorder.soundPlayer.playSound(TheBorderSound.SCATTER_ANTICIPATION);
            this._scatterAnticipationSoundPlayed = true;

            TheBorder.soundPlayer.fadeMusic({
                name: "",
                duration: 500,
                to: 0.7
            });
        }
    }

    public stopHighlight(): void {
        this._animation.state.clearTracks();
        this._animation.visible = false;

        if (this._scatterAnticipationSoundPlayed) {
            const allScatterSymbols: TheBorderScatterSymbol[] = TheBorder.scatterSymbols.getAllUsedSymbols();
            let scatterCount: number = 0;
            allScatterSymbols.forEach((sym: TheBorderScatterSymbol) => {
                scatterCount += sym.splitLevel;
            });
            if (scatterCount > 0 && scatterCount < 6) {
                TheBorder.soundPlayer.playSound(TheBorderSound.SCATTER_UNLOCK_FAIL);

                TheBorder.soundPlayer.fadeMusic({
                    name: "",
                    duration: 500,
                    to: 1
                });
            }
        }
        TheBorder.soundPlayer.fadeOutEffect({
            name: TheBorderSound.SCATTER_ANTICIPATION,
            to: 0,
            duration: 100
        });
        this._scatterAnticipationSoundPlayed = false;
    }

    private init(): void {
        this._animation = new PIXI.spine.Spine(TheBorder.assetLoader.getSpineAsset(TheBorderGameAssets.X_RIP_REEL_HIGHLIGHTER));
        this._animation.visible = false;
        this._animation.position.set(0, 390);
        this.addChild(this._animation);
    }

    private resetSpine(): void {
        if (!this._animation.visible) {
            this._animation.visible = true;
            this._animation.updateTransform();
        }
        this._animation.state.clearTracks();
        this._animation.skeleton.setSlotsToSetupPose();
        this._animation.skeleton.setToSetupPose();
        this._animation.state.setEmptyAnimation(0, 0);
    }
}